import { EmailNotificationItem } from './components/EmailNotificationItem'
import { SMSNotificationItem } from './components/SMSNotificationItem'
import { VoiceCallNotificationItem } from './components/VoiceCallNotificationItem'

interface Props {
  item: uui.domain.client.rm.OrderStepNotification
  showModal: (data: uui.domain.client.rm.OrderStepNotification) => void
}

export function OrderStepNotificationItem(props: Props) {
  const { item, showModal } = props

  switch (item.kind) {
    case 'SMS':
      return <SMSNotificationItem item={item} showModal={showModal} />

    case 'EMAIL':
      return <EmailNotificationItem item={item} showModal={showModal} />

    case 'MASKED_CALL':
      return <VoiceCallNotificationItem item={item} />
  }
}
